import axios from 'axios'

export default async function deleteInterest(id: number) {
  await axios.delete(`/api/v1/interest/${id}/`)
}
